import { Link } from 'react-router-dom'
import { Icon } from '../../components/icons/Icon'
import type { ColumnDef } from '../../design-system/list-view/types'
import { label } from '../../lib/labels'
import type { LegalEntityView } from '../../types/account'

/**
 * Column set for the Legal Entities `RelatedList` embedded on `AccountDetailScreen`
 * (docs/design/IB-49-crm-detail-timeline-design.md §5.4) — a real M23 `ListView` instantiation,
 * not a reduced inline table (FR-M5.2's AC).
 */
export function buildLegalEntityColumns(): ColumnDef<LegalEntityView>[] {
  return [
    {
      id: 'name',
      header: 'Legal entity',
      width: 240,
      minWidth: 180,
      sortable: true,
      pinnable: true,
      toExportText: (row) => row.name,
      render: (row) => (
        <Link
          to={`/clients/legal-entities/${row.id}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--iw-accent)', textDecoration: 'none' }}
        >
          <Icon name="landmark" size={14} />
          {row.name}
        </Link>
      ),
    },
    {
      id: 'jurisdiction',
      header: 'Jurisdiction',
      width: 140,
      sortable: true,
      toExportText: (row) => label('jurisdiction', row.jurisdiction),
      render: (row) => label('jurisdiction', row.jurisdiction),
    },
    {
      id: 'taxIdentifiers',
      header: 'Tax IDs',
      width: 100,
      sortable: false,
      toExportText: (row) => String(row.taxIdentifiers.length),
      render: (row) => row.taxIdentifiers.length,
    },
    {
      id: 'createdAt',
      header: 'Created',
      width: 120,
      sortable: true,
      defaultHidden: true,
      toExportText: (row) => row.createdAt,
      render: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
  ]
}

export const LEGAL_ENTITY_COLUMN_ORDER = ['name', 'jurisdiction', 'taxIdentifiers', 'createdAt']
